module.exports = __webpack_public_path__ + "img/vision.2559d9dc.jpg";